export default function OverviewSection() {
  return (
    <section className="py-12 md:py-16">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-4xl mx-auto">
          <div className="glass-card p-6 md:p-10">
            <p className="text-base md:text-lg text-silver-200 leading-relaxed mb-6">
              Every business operates differently and sometimes, off-the-shelf solutions are not enough.
            </p>
            <p className="text-base md:text-lg text-silver-200 leading-relaxed mb-6">
              At StackMap Systems, we design and build custom applications tailored to your specific workflows, processes, and operational needs. Whether you are managing complex logistics, distributed teams, or unique business models, our bespoke development approach ensures that your systems are built around how your business actually runs, not the other way around.
            </p>
            <p className="text-base md:text-lg text-silver-200 leading-relaxed mb-8">
              We work closely with your team to understand your operations, identify gaps, and develop solutions that deliver structure, visibility, and control across your business.
            </p>
            <p className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              From internal tools to full-scale platforms, our bespoke solutions are:
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-emerald-accent/15 flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-xs text-emerald-accent" />
                </div>
                <span className="text-sm text-silver-200">Fully aligned with your business processes</span>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-emerald-accent/15 flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-xs text-emerald-accent" />
                </div>
                <span className="text-sm text-silver-200">Scalable as your operations grow</span>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-emerald-accent/15 flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-xs text-emerald-accent" />
                </div>
                <span className="text-sm text-silver-200">Integrated with your existing systems where required</span>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-emerald-accent/15 flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-xs text-emerald-accent" />
                </div>
                <span className="text-sm text-silver-200">Designed for ease of use and real-world execution</span>
              </div>
            </div>
            <p className="text-base md:text-lg text-silver-200 leading-relaxed">
              If your business needs something beyond standard software, we build systems that fit precisely.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}